import { z } from 'zod';
import { agencyTaskPrioritySchema } from '../agency-tasks/list';

export const clientAreaTaskPostSchema = z.object({
  id: z.string(),
  title: z.string(),
});

export const clientAreaTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  dueDate: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
  priority: agencyTaskPrioritySchema,
  post: clientAreaTaskPostSchema.nullable(),
});

export const clientAreaTasksResponseSchema = z.object({
  tasks: z.array(clientAreaTaskSchema),
});

export type ClientAreaTaskPostSchema = z.infer<typeof clientAreaTaskPostSchema>;
export type ClientAreaTaskSchema = z.infer<typeof clientAreaTaskSchema>;
export type ClientAreaTasksResponseSchema = z.infer<typeof clientAreaTasksResponseSchema>;
